import { cva, type VariantProps } from "./style.utils";

export type FieldVariants = VariantProps<typeof fieldVariants>;

export const fieldVariants = cva({
  base: "flex flex-col gap-10px",
});
